import React from 'react'
import PropTypes from 'prop-types'
import AgentGrid from 'Components/AgentGrid'
import ToTopOnMount from 'Components/ToTopOnMount'
import { useConfiguration } from 'Root/ConfigurationProvider'
import AppHelmet from 'Components/AppHelmet'
import SectionHeader from 'Components/SectionHeader'
import PageExtraLinks from 'Components/PageExtraLinks'

import { Hero, MaxWidthGrid } from 'Layout'

import getMetaTags from './metaTags'

import { _Hero, _Title, subtitleCss } from './styles'

const AgentList = ({ areas, isMobile }) => {
  const { THEME_NAME, IS_MRLOFT } = useConfiguration()

  const heroText = IS_MRLOFT ? 'Loft Specialists' : 'Realtors'
  // since this page is not in lookup, ssr initial load will show toronto
  const currentArea = areas ? areas.label : 'Toronto'
  const heroImg = `static/images/hero_image_${THEME_NAME}${isMobile ? '_mobile' : ''}.jpg`
  const heroHeight = '45vh'
  const heroTitle = `Our Team of ${currentArea} ${heroText}`
  const heroSubtitle = 'Discover why our REALTORS are specialists - and why that matters to you.'
  let headerTagsJson = null
  try {
    headerTagsJson = JSON.stringify(getMetaTags(currentArea))
  } catch(e) {
    headerTagsJson = null
  }
  return (
    <main id="heap-AgentList" tabIndex="-1">
      <ToTopOnMount />
      <AppHelmet fallback={headerTagsJson} />
      <Hero
        image={heroImg}
        height={heroHeight}
        bgOpacity={0.3}
        backgroundPosition="0 70%"
      >
        <_Hero>
          <_Title>{heroTitle}</_Title>
          <SectionHeader
            secondary
            title={heroSubtitle}
            headerClassCss={subtitleCss}
          />
        </_Hero>
      </Hero>
      <AgentGrid areas={areas} />


      <MaxWidthGrid>
        <PageExtraLinks />
      </MaxWidthGrid>
    </main>
  )
}


AgentList.propTypes = {
  isMobile: PropTypes.bool,
  areas: PropTypes.shape({
    label: PropTypes.string,
  }),
}

export default AgentList
